import React from 'react'

const EditAuditContext = React.createContext()

function EditAuditContextProvider(props) {
  const [edited_start_date, setEditStartDate] = React.useState('')
  const [edited_audit_entities_attributes, setEditGroupDetails] = React.useState([
    {
      entity_id: '',
      entity_name: '',
      audit_entity_field_attributes: {field_id: '', field_name: ''},
      audit_entity_filters_attributes: [],
      audit_entity_auto_update_fields_attributes: [],
      audit_entity_user_fields_attributes: [],
    },
  ])
  const [random, setRandom] = React.useState(1)

  const value = {
    edited_start_date,
    edited_audit_entities_attributes,
    random,

    setEditStartDate,
    setEditGroupDetails,
    setRandom,
  }
  return <EditAuditContext.Provider value={value}>{props.children}</EditAuditContext.Provider>
}

const EditAuditContextConsumer = EditAuditContext.Consumer

export {EditAuditContext, EditAuditContextProvider, EditAuditContextConsumer}
